module.exports = __webpack_public_path__ + "static/img/plannermes.969f591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/plannermes.png
// module id = Wl8O
// module chunks = 0